import {AppIdentifiers, ITopicHeaders} from '@sparkware/uc-sdk-core';

export const STANDARD_TOPIC_HEADER: ITopicHeaders = {
    publisher: AppIdentifiers.CasinoClient
};

